(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    // Prevent binding multiple times (theme editor, section reloads, etc.)
    if (window.__emailSignupAjaxBound) return;
    window.__emailSignupAjaxBound = true;

    async function fetchSectionHtml(sectionId) {
      const url = `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`;
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to reload section');
      return await res.text();
    }

    function swapBlock(sectionHtml, sectionId, blockId) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');

      const selector = `.email-signup-block[data-section-id="${CSS.escape(sectionId)}"][data-block-id="${CSS.escape(
        blockId
      )}"]`;

      const newBlock = doc.querySelector(selector);
      const currentBlock = document.querySelector(selector);

      if (!newBlock || !currentBlock) {
        throw new Error('Could not find matching signup block in section HTML');
      }

      currentBlock.replaceWith(newBlock);

      // Optional: focus message if it exists (nice UX)
      const msg = newBlock.querySelector('.email-signup__message');
      if (msg) msg.focus?.();
    }

    async function handleSubmit(form) {
      const wrapper = form.closest('.email-signup-block');
      const sectionId = wrapper?.dataset?.sectionId;
      const blockId = wrapper?.dataset?.blockId;

      if (!sectionId || !blockId) return;

      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      try {
        const formData = new FormData(form);

        // POST without navigation
        const postRes = await fetch(form.action, {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
        });

        // Even if Shopify responds with an error, we re-render the section to show Liquid errors
        // (invalid email, etc.)
        if (!postRes.ok) {
          // continue to section reload
        }

        const sectionHtml = await fetchSectionHtml(sectionId);
        swapBlock(sectionHtml, sectionId, blockId);
      } catch (e) {
        console.error(e);

        // fallback UX (won't remove the page refresh, but gives feedback)
        const msg = wrapper?.querySelector('.email-signup__message');
        if (msg) {
          msg.classList.remove('email-signup__message--success');
          msg.classList.add('email-signup__message--error');
          msg.textContent = 'Something went wrong. Please try again.';
          msg.focus?.();
        } else {
          alert('Something went wrong. Please try again.');
        }
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    }

    // Delegated submit handler so it still works after DOM replacement
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('.email-signup-block .email-signup__form')) return;

      // Only AJAX-submit forms that have our wrapper data attributes
      const wrapper = form.closest('.email-signup-block[data-section-id][data-block-id]');
      if (!wrapper) return;

      e.preventDefault();
      handleSubmit(form);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
